module.exports = __webpack_public_path__ + "static/img/soul-journey-home-hover.0b9028c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/astrology/soul-journey-home-hover.png
// module id = pK/f
// module chunks = 0